<template>

  <div class="ob-content">
    <v-card>
      <issue-codes-table :source="source" @click="$router.push({ name: 'issue-codes/id', params: { id: $event.id} })" />
    </v-card>

    <v-btn fab fixed bottom right color="primary" @click="$router.push({ name: 'issue-codes/new' })">
      <v-icon>add</v-icon>
    </v-btn>
  </div>

</template>

<script>

import ApiService from '../../services/api.service.es6'
import IssueCodesTable from './components/issue-codes-table'

export default {
  data () {
    return {
      source: args => ApiService.findAllPaginated('issue-codes', null, args.sort, args.pagination)
    }
  },

  components: {
    IssueCodesTable
  }
}
</script>
